module.exports = function isUrlAbsolute (url) {
	return (url.indexOf(`://`) > 0 || url.indexOf(`//`) === 0)
}
